import {FC, useState} from 'react'
import {useStore} from '../../store'
import {useTemplateMode} from './useTemplateMode'
import {TemplateManagerModal} from './TemplateManagerModal'
import {useAuth, hasPermission, LABOR_SCHEDULING_PERMS} from '../../../auth'

// Toolbar switch for template mode. Turning it ON opens the template manager
// (create new / open existing); turning it OFF exits, with a discard-confirm
// when the draft has unsaved changes.
const TemplateModeToggle: FC = () => {
  const {selectedLocationId, templateMode} = useStore()
  const {requestExit} = useTemplateMode()
  const [showManager, setShowManager] = useState(false)
  const {currentUser} = useAuth()

  // Template editing maps to shift create/edit on the backend — hide the
  // whole editor entry point from view-only users.
  if (!hasPermission(currentUser, LABOR_SCHEDULING_PERMS.create, LABOR_SCHEDULING_PERMS.edit)) {
    return null
  }

  const handleToggle = () => {
    if (templateMode) {
      requestExit()
    } else {
      setShowManager(true)
    }
  }

  return (
    <>
      <div
        className='form-check form-switch form-switch-sm form-check-custom form-check-solid me-2'
        title={selectedLocationId ? 'Build reusable schedule templates' : 'Select a store first'}
      >
        <input
          className='form-check-input'
          type='checkbox'
          id='template_mode_toggle'
          checked={templateMode}
          disabled={!selectedLocationId}
          onChange={handleToggle}
        />
        <label
          className='form-check-label fs-7 fw-bold text-gray-700 flex-shrink-0'
          htmlFor='template_mode_toggle'
        >
          Templates
        </label>
      </div>
      <TemplateManagerModal show={showManager} onHide={() => setShowManager(false)} />
    </>
  )
}

export {TemplateModeToggle}
